// extracted by mini-css-extract-plugin
export default {"container":"LJ-z","dimension":"MJ-z","dimensionLabels":"NJ-z"};